export enum DashboardRoutes {
  ROOT = ''
}
